import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { Http, RequestOptions, XHRBackend } from '@angular/http';
import { MaterialModule, MdNativeDateModule, DateAdapter } from '@angular/material';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup

import { AppComponent } from './app.component';

//--------------------------------- HEADER
import { HeaderComponent } from './shared/components/header/header.component';
import { SubHeaderComponent } from './shared/components/header/sub-header.component';
import { FlowHeaderComponent } from './shared/components/header/flow-header.component';

//--------------------------------- LOGIN
import { LoginLoginComponent } from './login/components/login.component';
import { LoginRegisterComponent } from './login/components/register.component';
import { LoginRegistrationConfirmationComponent } from './login/components/registration-confirmation.component';
import { LoginRegistrationSuccessComponent } from './login/components/registration-success.component';
import { LoginResetPasswordComponent } from './login/components/reset-password.component';
import { LoginSetNewPasswordComponent } from './login/components/set-new-password.component';
import { LoginResetPassConfirmationComponent } from './login/components/reset-password-confirmation.component';
import { LoginChangePasswordComponent } from './login/components/change-password.component';

//--------------------------------- INFORMATION
import { InformationFaqComponent } from './information/components/faq.component';
import { InformationContactUsComponent } from './information/components/contact-us.component';

//--------------------------------- HOME
import { HomeComponent } from './home/components/home.component';
import { CustomerHomeComponent } from './home/components/customer-home.component';

//--------------------------------- PLANTMAP
import { PlantmapEarthworkDetailsComponent } from './plantmap/components/earthwork-details.component';
import { PlantmapAreaOfInterestComponent } from './plantmap/components/area-of-interest.component';
import { PlantmapUploadDocumentComponent } from './plantmap/components/upload-document.component';
import { PlantmapPaymentComponent } from './plantmap/components/payment.component';
import { PlantmapConfirmationComponent } from './plantmap/components/confirmation.component';
import { cancelconfirmation } from './plantmap/components/confirmation-cancel.component';//Kowsalya
import { timeoutconfirmation } from './plantmap/components/confirmation-timeout.component';//Kowsalya


//--------------------------------- NCE
import { NceFillInParticularsComponent } from './nce/components/fill-in-particulars.component';
import { NceFillInParticularsExtComponent } from './nce/components/fill-in-particulars-ext.component';
import { NceEarthworkDetailsComponent } from './nce/components/earthwork-details.component';
import { NceUploadAttachmentComponent } from './nce/components/upload-attachment.component';
import { NceDeclarationComponent } from './nce/components/declaration.component';
import { NcePreviewComponent } from './nce/components/preview.component';
import { NcePaymentComponent } from './nce/components/payment.component';
import { NceConfirmationComponent } from './nce/components/confirmation.component';
import { NceBriefingSessionComponent } from './nce/components/briefing-session.component';
import { NceMakeAppointmentComponent } from './nce/components/make-appointment.component';
import { NceApplyForFinalApprovalComponent } from './nce/components/apply-for-final-approval.component';
import { NceFinalApprovalComponent } from './nce/components/final-approval.component';
import { NceViewComponent } from './nce/components/view.component';

import { CustomerHistoryComponent } from './history/components/customer-history.component';
import { HistoryService } from './history/services/history.service';
import { CustomDateAdapter } from './shared/services/custom-date-adapter';

//--------------------------------- ADMIN
import { AdminHomeComponent } from './home/components/admin-home.component';
import { AdminCreateAccountComponent } from './admin/components/create-account.component';
import { AdminUserAccountComponent } from './admin/components/user-account.component';
import { AdminViewUserDetailsComponent } from './admin/components/view-user-details.component';
//GANESH
import { AdminReportComponent } from './admin/components/admin-report.component';

//--------------------------------- PLANTMAP-ADMIN
import { PlantmapOpsHomeComponent } from './home/components/plantmap-ops-home.component';
import { PlantmapAdminAllComponent } from './plantmap-admin/components/all.component';

//--------------------------------- NCE-ADMIN
import { NceOpsHomeComponent } from './home/components/nce-ops-home.component';
import { NceAdminAllComponent } from './nce-admin/components/all.component';
import { NceAdminRequestComponent } from './nce-admin/components/request.component';
import { NceBriefingDocumentComponent } from './nce/components/briefing-document.component';
import { NceAppointmentUploadComponent } from './nce/components/appointment-upload.component';

//--------------------------------- PROFILE
import { ProfileUpdateProfileComponent } from './profile/components/update-profile.component';

//--------------------------------- SERVICES
import { RegisterService } from './login/services/register.service';
import { ResetPasswordService } from './login/services/reset-password.service';

import { ProfileService } from './profile/services/profile.service';

import { PlantMapAdminService } from './plantmap-admin/services/plant-map-admin.service';
import { PlantMapService } from './plantmap/services/plant-map.service';
import { NceAdminService } from './nce-admin/services/nce-admin.service';
import { NceService } from './nce/services/nce.service';
import { AdminService } from './admin/services/admin.service';
import { ReportService } from './admin/services/report.service';

//--------------------------------- SHARED
import { ConfirmationPopupComponent } from './shared/components/popup/confirmation-popup.component';
import { ChangePasswordPopupComponent } from './shared/components/popup/change-password-popup.component';
import { ChangeSecurityQuestionPopupComponent } from './shared/components/popup/change-security-question-popup.component';
import { ViewPlantmapPopupComponent } from './shared/components/popup/view-plantmap-popup.component';
import { ChangeAppointmentPopupComponent } from './shared/components/popup/change-appointment-popup.component';
import { RestrictedConfirmationPopupComponent } from './shared/components/popup/restricted-confirmation-popup.component';
import { ResetUserPasswordPopupComponent } from './shared/components/popup/reset-user-password-popup.component';
import { PreviewChildComponent } from './shared/components/preview/preview-child.component';
import { EditPreviewChildComponent } from './admin/components/edit-preview-child.component';
import { ClickOutsideDirective } from './shared/components/click-outside.directive';
import { HorizontalSpinnerComponent } from './shared/components/spinners/horizontal-spinner.component';
import { CircularSpinnerComponent } from './shared/components/spinners/circular-spinner.component';

//--------------------------------- CONFIG

import { LoginTnCComponent } from './shared/configuration/login-tnc.component'; //Kowsalya
import { paymentTnCComponent } from './shared/configuration/payment-tnc.component'; //Kowsalya

//--------------------------------- SERVICES

import { AuthService } from './shared/services/auth.service';
import { PageNavigationService } from './shared/services/page-navigation.service';
import { StorageService } from './shared/services/storage.service';
import { LayoutService } from './shared/services/layout.service';
import { FileService } from './shared/services/file.service';
import { ErrorService } from './shared/services/error.service';
import { PopupService } from './shared/services/pop-up.service';
import { ValidationService } from './shared/services/validation.service';
import { EncryptionService } from './shared/services/encryption.service';
import { MyHttp } from './shared/services/my-http.service';

import { InNavGuardService,OutNavGuardService } from './shared/services/nav-guard.service';

import { routing } from './app.routes';

import { DataTableModule, SharedModule } from 'primeng/primeng';
import { MaintenanceComponent } from 'app/information/components/maintenance.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { PrivacyComponent } from './information/components/privacy/privacy.component';//Anjaiah
import { TermsComponent } from './information/components/terms/terms.component';
import { ScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';//Anjaiah

export function HttpFactory(backend: XHRBackend,
    defaultOptions: RequestOptions,
    _pageNavigationService: PageNavigationService,
    _storageService: StorageService,
    _encryptionService: EncryptionService) {

    return new MyHttp(backend, defaultOptions, _pageNavigationService, _storageService,_encryptionService);

}

@NgModule({
    declarations: [
        AppComponent,
        ClickOutsideDirective,
        HeaderComponent,
        SubHeaderComponent,
        FlowHeaderComponent,
        LoginLoginComponent,
        LoginRegisterComponent,
        LoginRegistrationConfirmationComponent,
        LoginRegistrationSuccessComponent,
        LoginResetPassConfirmationComponent,
        LoginResetPasswordComponent,
        LoginSetNewPasswordComponent,
        LoginChangePasswordComponent,
        InformationFaqComponent,
        InformationContactUsComponent,
        HomeComponent,
        CustomerHomeComponent,
        CustomerHistoryComponent,
        PlantmapEarthworkDetailsComponent,
        PlantmapAreaOfInterestComponent,
        PlantmapUploadDocumentComponent,
        PlantmapPaymentComponent,
        PlantmapConfirmationComponent,
        NceFillInParticularsComponent,
        NceFillInParticularsExtComponent,
        NceEarthworkDetailsComponent,
        NceUploadAttachmentComponent,
        NceDeclarationComponent,
        NcePreviewComponent,
        NcePaymentComponent,
        NceConfirmationComponent,
        NceBriefingSessionComponent,
        NceMakeAppointmentComponent,
        NceFinalApprovalComponent,
        NceViewComponent,
        AdminHomeComponent,
        AdminCreateAccountComponent,
        AdminUserAccountComponent,
        AdminViewUserDetailsComponent,
        PlantmapOpsHomeComponent,
        PlantmapAdminAllComponent,
        NceOpsHomeComponent,
        NceAdminAllComponent,
        NceAdminRequestComponent,
        NceBriefingDocumentComponent,
        NceAppointmentUploadComponent,
        NceApplyForFinalApprovalComponent,
        ProfileUpdateProfileComponent,
        PreviewChildComponent,
        EditPreviewChildComponent,
        ConfirmationPopupComponent,
        ChangePasswordPopupComponent,
        ChangeSecurityQuestionPopupComponent,
        ViewPlantmapPopupComponent,
        ChangeAppointmentPopupComponent,
        RestrictedConfirmationPopupComponent,
        ResetUserPasswordPopupComponent,
        HorizontalSpinnerComponent,
        CircularSpinnerComponent,
        MaintenanceComponent,
        LoginTnCComponent, //Kowsalya
        paymentTnCComponent,//Kowsalya
        cancelconfirmation,//Kowsalya
        timeoutconfirmation,//Kowsalya
        AdminReportComponent, FooterComponent, PrivacyComponent, TermsComponent, ScrollToTopComponent //GANESH
        
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        FormsModule,
        routing,
        MaterialModule,
        MdNativeDateModule,
        DataTableModule,
        NgIdleKeepaliveModule.forRoot()
    ],
    providers: [
        AuthService,
        RegisterService,
        PopupService,
        ResetPasswordService,
        ProfileService,
        StorageService,
        EncryptionService,
        PageNavigationService,
        LayoutService,
        ErrorService,
        EncryptionService,
        ValidationService,
        InNavGuardService,
        OutNavGuardService,
        AdminService,
        PlantMapService,
        PlantMapAdminService,
        NceService,
        NceAdminService,
        HistoryService,
        ReportService, //GANESH
        FileService,
        {
            provide: Http,
            useFactory: HttpFactory,
            deps: [XHRBackend, RequestOptions, PageNavigationService, StorageService,EncryptionService]
        },
        { 
            provide: DateAdapter, 
            useClass: CustomDateAdapter 
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/app.module.ts